import { SettingOutlined } from "@ant-design/icons";
import React, { useState, useEffect } from "react";
import "../../styles.scss";
import MegaTable from "../../../../components/MagaTableV2";
import { formatNumber } from '../../../../services/mixin';
import { mixGetV2 } from '../../../../services/mixin'
import { useSelector } from 'react-redux';
import { selectorInfoUser } from '../../../../store/slices/infoUserSlice';

const WarrantyInformation = ({ stData = {} as any, stChange = (data: any, type: any) => { } }) => {
  const user = useSelector(selectorInfoUser);
  const tableColumns = (sourceColumnWarehouse: any) => {
    const temp = [] as any
    sourceColumnWarehouse.vehicle_owner_insurance?.list.map((col: any) => {
      if (col.field === 'original_amount') {
        temp.push({
          headerName: col.headerName,
          field: col.field,
          tooltipField: col.field,
          valueFormatter: (params: any) => formatNumber(params.value)
        })
      } else {
        temp.push({
          headerName: col.headerName,
          field: col.field,
          tooltipField: col.field,
        })
      }
    })
    return temp
  }
  const [megaTableData, setMegaTableData] = useState<any>({
    name: 'TbCacheWarrantyInformation',
    col: [
      ...tableColumns(stData.sourceColumnWarehouse),
    ],
    listData: [],
    hideRowsSelect: true,
    showSetting: false,
    loading: false,
    height: '400px',
  });

  const [loading, setLoading] = useState(false);
  const getDetail = async (id: any) => {
    setLoading(true);
    const res = await mixGetV2(`/api/v1/be/customer/vehicle_insurance?id_vehicle=${id}&admin_id=${user.id}`);
    if (res.data) {
      stChange(res.data, 'vehicle_insurance');
      setLoading(false);
    }
  }
  useEffect(() => {
    if (stData.xesohuu_show && stData.xesohuu_show.id) {
      getDetail(stData.xesohuu_show.id);
    }
  }, [stData.xesohuu_show]);

  return (
    <>
      <div className="setting-tb-has-tab">
        <div className='settingCol'>
          <div className='ctr-col-setting' onClick={() => setMegaTableData((prev: any) => ({ ...prev, showSetting: true }))}>
            <SettingOutlined />
          </div>
        </div>
      </div>
      <MegaTable
        stData={{ ...megaTableData, listData: stData.xesohuu_show_vehicle_insurance || [], loading: loading }}
        stChange={(data) => {
          setMegaTableData((prev: any) => ({ ...prev, ...data }));
        }}
      />
    </>
  );
};
export default WarrantyInformation;
